import { Grid2 } from '@mui/material';

const Container = ({ flexWrap, children }) => {
    return (
        <Grid2 container size={{ xs: 6, md: 12 }} gap="16px" justifyContent="flex-start" alignItems="center" width="100%" flexWrap={flexWrap ? flexWrap : { xs: 'wrap', md: 'nowrap' }}>
            {children}
        </Grid2>
    );
};

export default Container;
